
// as of now, ola is not having maps so using google for now here
import OlaMapsInit from "./ola-maps-init";

class OlaMaps extends OlaMapsInit {
    constructor() {
        super();
        this._map = null;
    }

    initMap() {
        let instance = this._map;
        if (!instance) {
            instance = new (this.getMap())(...arguments);
        }
        this._map = instance;
        return this._map;
    }

    reInitMap() {
        const instance = new (this.getMap())(...arguments);
        this._map = instance;
        return this._map;
    }

    initMarker() {
        return new (this.getMarker())(...arguments);
    }

    initInfoWindow() {
        return new (this.getInfoWindow())(...arguments);
    }

    centerToPosition({
        marker,
        position,
        markerIcon,
        infoWindow,
        infoWindowContent
    }) {
        if (marker.setPosition) {
            marker.setPosition(position);
            marker.setIcon(markerIcon);
            if (infoWindow && infoWindowContent) {
                infoWindow.setContent(infoWindowContent);
                infoWindow.open(this._map, marker);
            }
            this._map.setCenter(position);
        }
    }

    panTo({ lat, lng }) {
        this._map.panTo({ lat, lng });
    }

    addCenterChangedListener(callback) {
        return this.getEvent().addListener(this._map, "dragend", () => {
            const center = this._map.getCenter();
            callback({
                lat: center.lat(),
                lng: center.lng(),
                center
            });
        });
    }

    removeListener(event) {
        this.getEvent().removeListener(event);
    }
}

export default OlaMaps;
